import React from 'react';
import { useFormikContext } from 'formik';
import { NestedAttributes } from '../../../components';
import VariableInput, { DefaultVariableInput } from './VariableInputs';
import NotVariableInput, { DefaultNotVariableInput } from './NotVariableInputs';
/* import { debounceIndexBalancesRequest } from '../../../requests/balances';
import { resultFetchData } from '../helpers'; */

export default function BalanceInputs({
  variable,
  subVariable,
  dispatch,
  assets,
  discounts,
  isVariable,
  canCreate,
  canDestroy,
  allValuesAttributes,
  extraValueProps,
  balanceType,
  createOnClick
}) {
  const { errors, touched, values, setFieldValue } = useFormikContext();

  const initialValueBalance = (attributes, value) => {
    if (!value?.balanceId) return undefined;

    const vAttribute = attributes.find(e => e.id === value.balanceId);
    return vAttribute?.id ? value.balanceId : undefined;
  };

  const valuesAttributes = subVariable ? values[variable][subVariable] : values[variable];
  const valuePath = subVariable ? `${variable}[${subVariable}]` : variable;
  const allBalances = [];
  const Component = isVariable ? VariableInput : NotVariableInput;
  valuesAttributes.forEach((body, index) => {
    if (body._destroy) {
      allBalances.push(undefined);
      return;
    }
    const title = body.balanceType === 'asset' ? 'Haber' : 'Descuento';
    const key =
      body.balanceType === 'asset' ? `balance-asset-${index.toString()}` : `balance-discount-${index.toString()}`;
    const allOptions = body.balanceType === 'asset' ? assets : discounts;
    const defaultOptions = allOptions;
    const defaultValue = initialValueBalance(allOptions, body);
    const addon = '$';
    const response = (
      <Component
        key={key}
        addon={addon}
        defaultOptions={defaultOptions}
        defaultValue={defaultValue}
        valuePath={valuePath}
        disabledSelector={!canCreate && !canDestroy && !createOnClick}
        disabledAmount={!canCreate && !canDestroy && !createOnClick}
        errors={errors}
        dispatch={dispatch}
        index={index}
        setFieldValue={setFieldValue}
        touched={touched}
        title={title}
      />
    );
    allBalances.push(response);
  });

  allBalances.push(isVariable ? DefaultVariableInput() : DefaultNotVariableInput());
  return (
    <>
      <NestedAttributes
        rowClass="nested-row__settlement_settings"
        mapInputs={allBalances}
        arrayValues={allValuesAttributes}
        setFieldValue={setFieldValue}
        valuePath={valuePath}
        newAttributes={{ balanceId: '', amount: '', balanceType, isVariable, ...extraValueProps }}
        removeFirstItem
        createOnClick={createOnClick}
        canCreate={canCreate}
        canDestroy={canDestroy}
      />
    </>
  );
}
